"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const Alphaeon_Patient_Financing_Logo_png_1 = __importDefault(require("images/Alphaeon_Patient_Financing_Logo.png"));
const inline_colors_1 = require("inline-colors");
const merchant_portal_reducer_1 = require("merchant-portal-reducer");
const utils_1 = require("utils");
function Layout({ children, fetchAllLocationsForManager, fetchLocationDetails, currentLocation, }) {
    const history = (0, react_router_dom_1.useHistory)();
    const [closing, setClosing] = (0, react_1.useState)(false);
    const handleClose = async () => {
        try {
            setClosing(true);
            await fetchAllLocationsForManager();
            await fetchLocationDetails(currentLocation.locationId);
            sessionStorage.setItem('displayNewDeal', 'false');
            history.push({
                pathname: config_1.MERCHANT_PORTAL_URL,
                state: { from: '/new-deal' },
            });
            setClosing(false);
        }
        catch {
            setClosing(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "new-deal-container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "new-deal-header", children: [(0, jsx_runtime_1.jsx)("img", { src: Alphaeon_Patient_Financing_Logo_png_1.default, alt: "Alphaeon Credit" }), (0, jsx_runtime_1.jsx)("div", { className: "close-button-container", children: !closing ? ((0, jsx_runtime_1.jsx)(Close_1.default, { role: "button", className: "close-button", htmlColor: inline_colors_1.INLINE_COLORS.blackBase, onClick: handleClose, "data-testid": "new-deal-close-button" })) : ((0, jsx_runtime_1.jsx)(components_1.Spinner, {})) })] }), (0, jsx_runtime_1.jsx)("div", { className: "new-deal-main", children: children })] }));
}
function mapStateToProps(state) {
    return {
        currentLocation: merchant_portal_reducer_1.selectors.currentLocation(state),
    };
}
const mapApiAuthToProps = {
    fetchAllLocationsForManager: apiActions.fetchAllLocationsForManager,
    fetchLocationDetails: apiActions.fetchLocationDetails,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(Layout);
